// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8ba90f60","239":"05d1037d","453":"926f0775","455":"ed88db63","977":"d35724d6"}[chunkId] + ".chunk.js";
};